import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export default class IconButton extends React.Component {
   render() {
      let props = this.props;

      return <FontAwesomeIcon {...props} cursor={props.cursor ? props.cursor : 'pointer'} />;
   }
}